<template>
  <main-layout>

    <template slot="header">
      <span>User</span>
      <span v-if="customer"> : {{ customer.nickname || customer.fname + ' ' + customer.lname }}</span>
    </template>

    <template slot="main">
      <k-tabs class="container mx-auto bg-white p-4" v-if="customer">
        <k-tab :name="$t('common.about')" :selected="true">
          <form class="form-container">
            <div v-if="site && site.dnsproperties && !site.dnsproperties.includes('fname')" class="form-group">
              <label>Firstname</label>
              <label class="input">{{ customer.fname || "-" }}</label>
            </div>
            <div v-if="site && site.dnsproperties && !site.dnsproperties.includes('lname')" class="form-group">
              <label>Lastname</label>
              <label class="input">{{ customer.lname || "-" }}</label>
            </div>
            <div class="form-group">
              <label>Nickname</label>
              <label class="input">{{ customer.nickname || "-" }}</label>
            </div>
            <div v-if="site && site.dnsproperties && !site.dnsproperties.includes('email')" class="form-group">
              <label>Email</label>
              <label class="input">{{ customer.email || "-" }}</label>
            </div>
            <div class="form-group">
              <label>Gender</label>
              <label class="input">{{ customer.gender || "-" }}</label>
            </div>
            <div class="form-group">
              <label>Creation</label>
              <label class="input">{{ customer.datecreation || "-" }}</label>
            </div>
            <div class="form-group">
              <label>Last connection</label>
              <label class="input">{{ customer.dateconnection || "-" }}</label>
            </div>
            <div class="form-group">
              <label>UUID</label>
              <label class="input">{{ customer.uuid || "-" }}</label>
            </div>
          </form>
        </k-tab>
        <k-tab :name="$t('common.activities')">
          <activities-list :id="id"></activities-list>
        </k-tab>
        <k-tab :name="$t('common.badges')">
          <badges-list :id="id"></badges-list>
        </k-tab>
        <k-tab :name="$t('common.friends')">
          <friends-list :id="id"></friends-list>
        </k-tab>
      </k-tabs>
    </template>
  </main-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import activitiesList from '@/components/customers/customer-activities-list'
import badgesList from '@/components/customers/customer-badges-list'
import friendsList from '@/components/customers/customer-friends-list'

export default {
  name: 'customer',

  props: {
    id: {
      type: String,
      required: true
    }
  },

  components: { activitiesList, badgesList, friendsList },

  computed: {
    ...mapGetters('account', {
      site: 'currentSite',
      lang: 'defaultLang'
    }),

    ...mapGetters('customers', {
      getById: 'getById'
    }),

    customer () {
      return this.getById(this.id)
    }
  },

  watch: {
    site: {
      handler: 'init',
      immediate: true
    }
  },

  methods: {
    ...mapActions('customers', ['loadCustomerById']),

    init () {
      if (this.site && !this.customer) {
        this.loadCustomerById({id: this.id})
      }
    }
  }
}

</script>

<style lang="scss" scoped>

.customer {
  .section {
    display: grid;
    grid-template-columns: 1fr 3fr;
    grid-gap: 20px;
    border-top: 1px solid #dedede;
    padding:32px 0;

    &.no-border {
      border-top: 0;
    }
  }
}

.form-container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 24px;

  .form-group {
    label {
      display: block;

      &.input {
        background:#fafafa;
        border:1px solid #dadada;
        border-radius: 4px;
        color: #565656;
        font-weight: 400;
        padding: 12px;
        cursor: text;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Customer/Customer.vue